import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { exchangeSession, useAuth } from "@/lib/auth";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    const target = location.pathname + location.search;
    exchangeSession(sessionId)
      .then((user) => {
        setUser(user);
        toast.success(`Signed in as ${user.name || user.email}`);
      })
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(() => navigate(target, { replace: true }));
  }, [location, navigate, setUser]);

  return null;
};

export default AuthCallback;
